import { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import i18n from 'i18n';
import { CUSTOM_TABS_DIRECTION } from 'components/constants';
import CustomTabs from 'components/CustomTabs';
import i18nContext from 'components/i18n-context';
import { ROUTE_PATHS } from 'routes/constants';
import { FULL_ACCESS, hasRole } from 'services/roles';
import { Container } from 'uikit/Container/Container';
import './Settings.scss';

const SETTINGS_TABS = [
  {
    name: 'configuration',
    title: i18n.getMessage('settings.tab.configuration'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_CONFIGURATION
  },
  {
    name: 'paymentCutoffTimes',
    title: i18n.getMessage('settings.tab.paymentCutoffTimes'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_PAYMENTS_CUTOFF_TIMES
  },
  {
    name: 'blacklists',
    title: i18n.getMessage('settings.tab.blacklists'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_BLACKLISTS
  },
  {
    name: 'maintenance',
    title: i18n.getMessage('settings.tab.maintenance'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_MAINTENANCE
  },
  {
    name: 'highRiskCountries',
    title: i18n.getMessage('settings.tab.highRiskCountries'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_HIGH_RISK_COUNTRIES
  },
  {
    name: 'documentRequests',
    title: i18n.getMessage('settings.tab.documentRequests'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_DOCUMENT_REQUESTS
  },
  {
    name: 'integrations',
    title: i18n.getMessage('settings.tab.integrations'),
    icon: null,
    route: ROUTE_PATHS.SETTINGS_INTEGRATIONS,
    permission: FULL_ACCESS
  }
];

// A tab stays active on its nested pages, e.g. a single integration setting
const isTabRoute = (tab, path) => path === tab.route || path.startsWith(`${tab.route}/`);

const Settings = () => {
  const i18n = useContext(i18nContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(null);
  const settingsTabs = SETTINGS_TABS.filter((tab) => !tab.permission || hasRole(tab.permission));

  useEffect(() => {
    const path = location.pathname;

    const activeTabFromPath = settingsTabs.find((tab) => isTabRoute(tab, path));
    if (activeTabFromPath) {
      setActiveTab(activeTabFromPath.name);
    } else if (path === ROUTE_PATHS.SETTINGS) {
      setActiveTab(settingsTabs[0].name);
      navigate(settingsTabs[0].route);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, navigate]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    const selectedTab = settingsTabs.find((tab) => tab.name === tabName);
    if (selectedTab) {
      navigate(selectedTab.route);
    }
  };

  return (
    <section className={'right-section'}>
      <Container className={'settings-container'} header={i18n.getMessage('container.settings')}>
        <div className={'settings-wrapper'}>
          <CustomTabs
            tabList={settingsTabs}
            direction={CUSTOM_TABS_DIRECTION.HORIZONTAL}
            activeTab={activeTab}
            setActiveTab={handleTabChange}
          />
          <Outlet />
        </div>
      </Container>
    </section>
  );
};

export default Settings;
